import React from 'react';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import { Button } from '@sls-react/components/Form/Button';
import A from '@sls-react/components/Links/A';
import BlockSection from '@sls-react/components/legos/BlockSection';

interface Props {
  block: RailsBlock;
  headerType?: 'h1' | 'h2' | 'h3';
}

const TextPillsBlock: React.FC<Props> = ({ block, headerType }) => {
  if (!block.tiles?.length) {
    return null;
  }

  return (
    <BlockSection block={block} headerType={headerType}>
      <div className="flex flex-wrap -mb-2">
        {block.tiles.map(tile => {
          if (tile.destination) {
            return (
              <Button
                as={A}
                size="small"
                variant="outlined"
                color="black"
                className="mb-2 mr-2"
                key={tile.id}
                // @ts-ignore
                href={tile.destination}
              >
                {tile.name}
              </Button>
            );
          } else {
            return (
              <Button
                key={tile.id}
                size="small"
                className="mb-2 mr-2"
                variant="outlined"
                color="black"
              >
                {tile.name}
              </Button>
            );
          }
        })}
      </div>
    </BlockSection>
  );
};

export default TextPillsBlock;
